import type { EntityType } from "../../../../../../types/types.MDM";
import {
  MAX_COMPARE_PRODUCTS,
  MIN_COMPARE_PRODUCTS,
} from "../../../../../SharedPages/OrganizationPage/ProductsList/CompareProducts";

export { MAX_COMPARE_PRODUCTS, MIN_COMPARE_PRODUCTS };

export const COMPARE_ENTITY_META_KEYS: Record<EntityType, string> = {
  customer: "compareCustomerMeta",
  supplier: "compareSupplierMeta",
  distributor: "compareDistributorMeta",
};

export const SELECTED_ENTITY_ROWS_KEYS: Record<EntityType, string> = {
  customer: "selectedCustomerRows",
  supplier: "selectedSupplierRows",
  distributor: "selectedDistributorRows",
};

export type CompareEntityMeta = {
  entity_number: string | null;
  id: string;
  template_id: string | null;
  name: string;
};

export function loadCompareEntityMeta(
  entityType: EntityType
): Record<string, CompareEntityMeta> {
  try {
    const raw = sessionStorage.getItem(COMPARE_ENTITY_META_KEYS[entityType]);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveCompareEntityMeta(
  entityType: EntityType,
  meta: Record<string, CompareEntityMeta>
) {
  sessionStorage.setItem(
    COMPARE_ENTITY_META_KEYS[entityType],
    JSON.stringify(meta)
  );
}

export function mergeCompareEntityMetaFromTable(
  entityType: EntityType,
  selectedIds: string[],
  tableRows: Array<{
    id: string;
    entity_number: string | null;
    template_id?: string | null;
    name: string;
  }>
) {
  const meta = loadCompareEntityMeta(entityType);
  for (const row of tableRows) {
    if (!selectedIds.includes(row.id)) continue;
    const existing = meta[row.id];
    meta[row.id] = {
      id: row.id,
      entity_number: row.entity_number ?? existing?.entity_number ?? null,
      template_id: row.template_id ?? existing?.template_id ?? null,
      name: row.name || existing?.name || row.id,
    };
  }
  const selected = new Set(selectedIds);
  const next: Record<string, CompareEntityMeta> = {};
  for (const [key, value] of Object.entries(meta)) {
    if (selected.has(key)) next[key] = value;
  }
  saveCompareEntityMeta(entityType, next);
  return next;
}

export function clearCompareEntitySession(entityType: EntityType) {
  sessionStorage.removeItem(COMPARE_ENTITY_META_KEYS[entityType]);
  sessionStorage.removeItem(SELECTED_ENTITY_ROWS_KEYS[entityType]);
}
